// extracted by mini-css-extract-plugin
export default {"mainContainer":"PrivacyPolicyPage_mainContainer__6Enz6"};